"use strict";

exports.__esModule = true;
exports.DISCLAIMER_TOKEN_GLOBAL_REGEX = exports.DISCLAIMER_MATCH_GROUP_INDEX = exports.DISCLAIMER_ID_REGEX = void 0;
var DISCLAIMER_TOKEN_GLOBAL_REGEX = /\s/g;
exports.DISCLAIMER_TOKEN_GLOBAL_REGEX = DISCLAIMER_TOKEN_GLOBAL_REGEX;
var DISCLAIMER_ID_REGEX = /(.*?)#([a-zA-Z0-9*+^#]+)#(.*)/;
exports.DISCLAIMER_ID_REGEX = DISCLAIMER_ID_REGEX;
var DISCLAIMER_MATCH_GROUP_INDEX = 2;
exports.DISCLAIMER_MATCH_GROUP_INDEX = DISCLAIMER_MATCH_GROUP_INDEX;